import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "pdr-cookie-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // small delay so it doesn't appear instantly
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const save = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    localStorage.setItem(`${STORAGE_KEY}-date`, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] p-4 md:p-6 animate-fade-up"
      role="dialog"
      aria-labelledby="cookie-title"
    >
      <div className="max-w-[1400px] mx-auto bg-[#0A0A0A] border border-white/15 shadow-2xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 p-5 md:p-7">
          <div className="flex items-start gap-4 flex-1">
            <div className="w-11 h-11 flex-shrink-0 bg-[#007AFF]/10 border border-[#007AFF]/30 flex items-center justify-center">
              <Cookie className="w-5 h-5 text-[#007AFF]" />
            </div>
            <div className="flex-1">
              <div
                id="cookie-title"
                className="font-heading text-base md:text-lg font-bold uppercase tracking-tight mb-1"
              >
                Cookies & vie privée
              </div>
              <p className="text-sm text-white/70 leading-relaxed">
                Nous utilisons des cookies pour améliorer votre expérience
                et mesurer notre audience. Vous pouvez accepter ou
                refuser ces cookies non essentiels. En savoir plus dans
                notre{" "}
                <Link
                  to="/cookies"
                  className="text-[#007AFF] hover:underline"
                >
                  politique de cookies
                </Link>
                .
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 w-full md:w-auto">
            <button
              onClick={() => save("refused")}
              data-testid="cookie-refuse"
              className="flex-1 md:flex-none border border-white/20 hover:border-white/50 text-white text-xs font-bold uppercase tracking-widest px-6 py-3 transition-colors"
            >
              Refuser
            </button>
            <button
              onClick={() => save("accepted")}
              data-testid="cookie-accept"
              className="flex-1 md:flex-none bg-[#007AFF] hover:bg-[#3B82F6] text-white text-xs font-bold uppercase tracking-widest px-6 py-3 transition-colors"
            >
              Tout accepter
            </button>
          </div>

          <button
            onClick={() => save("refused")}
            aria-label="Fermer"
            className="absolute top-3 right-3 md:static w-8 h-8 flex items-center justify-center text-white/50 hover:text-white transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* French flag bottom line */}
        <div className="flex h-[3px]">
          <div className="flex-1 bg-[#0055A4]" />
          <div className="flex-1 bg-white" />
          <div className="flex-1 bg-[#EF4135]" />
        </div>
      </div>
    </div>
  );
};
